import axios from 'axios'

export const fetchOrderConversation = (supplierOrderId, supplierId) =>
  axios
    .get(`/authenticated/order-conversations/${supplierOrderId}`, {
      params: { supplierId }
    })
    .then((res) => res.data)

export const fetchOrderConversationHistory = (supplierId) =>
  axios
    .get('/authenticated/order-conversations', { params: { supplierId } })
    .then((res) => res.data)

export const downloadOrderConversationTranscript = (
  supplierOrderId,
  supplierId
) =>
  axios
    .get(`/authenticated/order-conversations/${supplierOrderId}/transcript`, {
      params: { supplierId },
      responseType: 'blob'
    })
    .then((res) => res.data)

export const sendOrderConversationMessage = (
  supplierOrderId,
  supplierId,
  body
) =>
  axios
    .post(
      `/authenticated/order-conversations/${supplierOrderId}/messages`,
      { body },
      { params: { supplierId } }
    )
    .then((res) => res.data)
